import { a1 as experimental_async_required, $ as get_render_context, a2 as hydratable_serialization_failed, V as ssr_context, n as noop, a3 as lifecycle_function_unavailable, a4 as createContext, a5 as getAbortSignal, a6 as getAllContexts, g as getContext, a7 as hasContext, s as setContext, a8 as run } from "./render-context.js";
import * as devalue from "devalue";
import "clsx";
function hydratable(key, fn) {
  {
    experimental_async_required();
  }
  const { hydratable: hydratable2 } = get_render_context();
  let entry = hydratable2.lookup.get(key);
  if (entry !== void 0) {
    return (
      /** @type {T} */
      entry.value
    );
  }
  const value = fn();
  entry = encode(key, value, hydratable2.unresolved_promises);
  hydratable2.lookup.set(key, entry);
  return value;
}
function encode(key, value, unresolved) {
  const entry = { value, serialized: "" };
  let uid = 1;
  entry.serialized = devalue.uneval(entry.value, (value2, uneval) => {
    if (is_promise(value2)) {
      const placeholder = `"${uid++}"`;
      const p = value2.then((v) => {
        entry.serialized = entry.serialized.replace(placeholder, `r(${uneval(v)})`);
      }).catch(
        (devalue_error) => hydratable_serialization_failed(
          key,
          serialization_stack(entry.stack, devalue_error?.stack)
        )
      );
      unresolved?.set(p, key);
      p.catch(() => {
      }).finally(() => unresolved?.delete(p));
      (entry.promises ??= []).push(p);
      return placeholder;
    }
  });
  return entry;
}
function is_promise(value) {
  return Object.prototype.toString.call(value) === "[object Promise]";
}
function serialization_stack(root_stack, uneval_stack) {
  let out = "";
  if (root_stack) {
    out += root_stack + "\n";
  }
  if (uneval_stack) {
    out += "Caused by:\n" + uneval_stack + "\n";
  }
  return out || "<missing stack trace>";
}
function createRawSnippet(fn) {
  return (renderer, ...args) => {
    var getters = (
      /** @type {Getters<Params>} */
      args.map((value) => () => value)
    );
    renderer.push(
      fn(...getters).render().trim()
    );
  };
}
function onDestroy(fn) {
  /** @type {SSRContext} */
  ssr_context.r.on_destroy(fn);
}
function createEventDispatcher() {
  return noop;
}
function mount() {
  lifecycle_function_unavailable("mount");
}
function hydrate() {
  lifecycle_function_unavailable("hydrate");
}
function unmount() {
  lifecycle_function_unavailable("unmount");
}
function fork() {
  lifecycle_function_unavailable("fork");
}
async function tick() {
}
async function settled() {
}
const svelte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  afterUpdate: noop,
  beforeUpdate: noop,
  createContext,
  createEventDispatcher,
  createRawSnippet,
  flushSync: noop,
  fork,
  getAbortSignal,
  getAllContexts,
  getContext,
  hasContext,
  hydratable,
  hydrate,
  mount,
  onDestroy,
  onMount: noop,
  setContext,
  settled,
  tick,
  unmount,
  untrack: run
}, Symbol.toStringTag, { value: "Module" }));
export {
  onDestroy as o,
  svelte as s,
  tick as t
};
